import { Component, input } from '@angular/core';
import { CardComponent } from '../card/card.component';
import { LinkComponent } from '../link/link.component';
import { ResponseScoreComponent } from '../../pages/admin-page/feedback/feedback-responses/response-score/response-score.component';

export interface MetricCardData {
  title: string;
  subtitle?: string;
  count: number;
  countTitle?: string;
  countSubtitle?: string;
  link?: string;
  linkLabel?: string;
  rating?: number;
}

@Component({
  selector: 'app-metric-card',
  imports: [ResponseScoreComponent, CardComponent, LinkComponent],
  templateUrl: './metric-card.component.html',
  styleUrl: './metric-card.component.css',
})
export class MetricCardComponent {
  public data = input.required<MetricCardData>();
}
